import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(email, password);
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      // Redirect to home and let React Router handle navigation
      window.location.href = '/';
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const quickLogin = (role: string) => {
    const credentials = {
      'system_admin': { email: 'admin@turkana.go.ke', password: 'admin123' },
      'county_officer': { email: 'county@turkana.go.ke', password: 'county123' },
      'ward_officer': { email: 'kakuma@turkana.go.ke', password: 'ward123' },
      'community_volunteer': { email: 'volunteer@turkana.go.ke', password: 'volunteer123' }
    };
    
    const cred = credentials[role as keyof typeof credentials];
    if (cred) {
      setEmail(cred.email);
      setPassword(cred.password);
      setError(''); // Clear any existing errors
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <div className="logo-section">
                <div className="logo">
                  <img src="/turkana.jpg" alt="Turkana County" style={{width: '32px', height: '32px'}} />
                </div>
                <div className="title-section">
                  <h1>Turkana Budgets and Accountability Platform</h1>
                  <p>Budget Transparency Platform</p>
                </div>
              </div>
              <div className="subtitle">
                <p>User Login Portal</p>
              </div>
            </div>

            {error && (
              <div className="error-alert">
                <span className="error-icon">⚠️</span>
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-group">
                <label>Email Address</label>
                <div className="input-wrapper">
                  <span className="input-icon">✉</span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Password</label>
                <div className="input-wrapper">
                  <span className="input-icon">🔐</span>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                  />
                </div>
              </div>

              <button type="submit" disabled={loading} className="login-btn">
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Signing in...
                  </>
                ) : (
                  <>
                    <span>→</span>
                    Sign In
                  </>
                )}
              </button>
            </form>

            <div className="divider">
              <span>Quick Access</span>
            </div>

            <div className="quick-login">
              <div className="role-buttons">
                <button 
                  onClick={() => quickLogin('system_admin')}
                  className="role-btn admin"
                >
                  <span>⚙</span>
                  <div>
                    <strong>System Admin</strong>
                    <small>Full platform access</small>
                  </div>
                </button>
                
                <button 
                  onClick={() => quickLogin('county_officer')}
                  className="role-btn county"
                >
                  <span>🏢</span>
                  <div>
                    <strong>Institutional Responder</strong>
                    <small>County-level management</small>
                  </div>
                </button>
                
                <button 
                  onClick={() => quickLogin('ward_officer')}
                  className="role-btn ward"
                >
                  <span>📍</span>
                  <div>
                    <strong>Civic Moderator</strong>
                    <small>Ward project updates</small>
                  </div>
                </button>
                
                <button 
                  onClick={() => quickLogin('community_volunteer')}
                  className="role-btn volunteer"
                >
                  <span>🤝</span>
                  <div>
                    <strong>Community Volunteer</strong>
                    <small>Document engagements</small>
                  </div>
                </button>
              </div>
            </div>

            <div className="public-access">
              <p>👤 <strong>Citizens:</strong> No login required for public access</p>
              <button 
                onClick={() => navigate('/')}
                className="public-btn"
              >
                Continue as Public User
              </button>
              <button 
                onClick={() => navigate('/feedback')}
                className="feedback-btn"
              >
                Submit Feedback
              </button>
              <button 
                onClick={() => navigate('/volunteer-apply')}
                className="volunteer-apply-btn"
              >
                Apply as Volunteer
              </button>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;